import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {TextInput} from 'admin-on-rest';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';

class KitFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kitId: null
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    }

    handleInputChange(e) {
        let inputValue = e.target.value;
        this.props.dispatch(change('filterForm', 'filter_kit_id', null));
        this.setState({
            kitId: inputValue
        });
    }

    handleFilterSubmit() {
        this.props.dispatch(change('filterForm', 'filter_kit_id', this.state.kitId));
    }

    render() {
        const {
            labelSubmit
        } = this.props;

        return (
            <form>
                <div className="list-filter">
                    <Field
                        name="filter_kit_id_input"
                        component={TextInput}
                        label='Type Kit ID'
                        optionText="filter_kit_id"
                        optionValue="id"
                        onChange={this.handleInputChange}
                        allowEmpty
                        options={{
                            className: 'has-label no-bottom-margin'
                        }}
                    />
                    <RaisedButton
                        primary
                        type="button"
                        label={labelSubmit}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButtonInline}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

KitFilter.propTypes = {
    labelSelect: PropTypes.string,
    labelSubmit: PropTypes.string,
    labelText: PropTypes.string
};

KitFilter.defaultProps = {
    labelSelect: 'Select a Kit ID',
    labelSubmit: 'Find',
    labelText: 'Enter a Kit ID'
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true
    })
);

export default enhance(KitFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/KitFilter.js